<template>
    <div class="demo-request">
        <div class="title">
            <h4>{{$t('demo.1st title')}}</h4>
            <div class="desc">
                <b>{{$t('demo.trial desc')}}</b>
            </div>
        </div>
        <form class="form" @submit.prevent="request">
            <div class="row row-root">
                <div class="col">
                    <div class="field">
                        <div class="label">{{$t('demo.phone')}}</div>
                        <input class="control"
                               :class="{'control-error': phoneError}"
                               type="tel"
                               ref="phone"
                               name="phone"
                               @countrychange="phoneChange"
                               @blur="phoneChange"
                               @keyup="phoneChange"
                               @change="phoneChange" />
                        <div v-if="phoneError" class="control-msg error">{{phoneError}}</div>
                    </div>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <div class="field">
                                <div class="label">{{$t('demo.language')}}</div>
                                <select class="control" name="language" v-model="language">
                                    <option v-for="lang of languages"
                                            :key="lang"
                                            :value="lang">
                                        {{$t('language.' + lang)}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col">
                            <div class="field">
                                <div class="label">{{$t('demo.currency')}}</div>
                                <select class="control" name="currency" v-model="currency">
                                    <option v-for="currency of currencies"
                                            :key="currency"
                                            :value="currency">
                                        [{{currency}}] {{$t('currency.' + currency)}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col-messenger">
                    <div class="field">
                        <div class="label">{{$t('demo.messenger')}}</div>
                        <div class="control-group">
                            <label class="control-checkbox" v-for="msg of messengers" :key="msg" :title="$t('messenger.'+msg)">
                                <input type="radio" name="messenger" :value="msg" v-model="messenger" />
                                <div>
                                    <span class="messenger" :class="msg">
                                        <i :class="'icon-'+msg"></i>
                                    </span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row row-root controls">
                <div class="col"></div>
                <div class="col center">
                    <button class="button" type="submit" :disabled="invalidForm">{{$t('demo.request')}}</button>
                </div>
                <div class="col center">
                    <div class="contacts">
                        <p class="desc">{{$t('demo.no configuration')}}</p>
                        <router-link :to="'/home#contacts'" class="button button-sm button-grey">{{$t('demo.contact us')}}</router-link>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import intlTelInput from "intl-tel-input/build/js/intlTelInput";
import axios from "axios";
import demoService from "../../services/demo.service";
import currencies from "./currencies";
import ga from '../../plugins/ganalitycs'


var phoneErrorMap = [
  "invalid number",
  "invalid country code",
  "too short",
  "too long",
  "invalid number"
];

export default {
  name: "demo-request-form",
  data() {
    return {
      loading: false,
      phoneText: null,
      phone: null,
      phoneError: null,
      language: null,
      currency: null,
      messenger: null,
      messengers: ["wa", "vb", "tg"],
      languages: ["en", "es", "fr", "ru"],
      currencies: ["USD", "EUR", "PEN", "COP", "RUB", "KZT"]
    };
  },
  computed: {
    invalidForm() {
      const numberPhone = this.phone && this.phone.replace("^d+", "");
      return !numberPhone || !numberPhone.match(/^\+[1-9]{1}[0-9]{1,14}$/);
    }
  },

  mounted() {
    if (this.languages.indexOf(this.$i18n.locale) > -1)
      this.language = this.$i18n.locale;

    this.currency = this.currencies[0];
    this.messenger = this.messengers[0];
    const that = this;    
  
    this.iti = intlTelInput(this.$refs.phone, {
      preferredCountries: ["us", "fr", "pe", "ru"],
      initialCountry: "auto",
      //nationalMode: true,
      utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.3/js/utils.js",      
      geoIpLookup(success, failure) {
        if (localStorage["geojs"]) {
          const geo = JSON.parse(localStorage["geojs"]);
          if (geo.exp > Date.now()) {
            success(geo.country);
            that._setCurrency(geo.currency);
            return;
          }
        }

        axios.get("https://get.geojs.io/v1/ip/country.json").then(r => {
          let response = Object.assign(
            {
              exp: Date.now() + 1 * 24 * 60 * 60 * 1000,
              currency: currencies[r.data.country.toUpperCase()]
            },
            r.data
          );
          localStorage["geojs"] = JSON.stringify(response);
          success(response.country);
          that._setCurrency(response.currency);
        });
      }
    });
  },
  beforeDestroy() {
    this.iti.destroy();
  },
  methods: {
    _setCurrency(currency) {
      if (this.currencies.indexOf(currency) > -1) {
        this.currency = currency;
      }
    },
    phoneChange() {
      this.phone = null;
      this.phoneError = null;
      if (!this.iti) return;

      if (this.iti.isValidNumber()) {
        this.phone = this.iti.getNumber();
      } else {
        this.phoneError = phoneErrorMap[this.iti.getValidationError()];
      }
    },
    async request() {
      try {
        this.loading = true;
        const request = {
          phone: this.phone,
          messenger: this.messenger,
          currency: this.currency,
          language: this.language
        };
        const resp = await demoService.request(request);
        ga.sendForm('requesttrialmbk777', 'trial');
        this.loading = false;
        this.$emit("complete", request);
      } catch (e) {
        console.error("Failed to send demo request", e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  margin: $spacer auto;
}

.controls {
  margin-top: $spacer * 2;
}

.title {
  font-size: 2.5rem;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: $spacer * 4;

   h4 {
        margin-top: 0;
        margin-bottom: $spacer;
    }

    .desc {
        font-size: 2rem;
        margin-bottom: $spacer;
    }
}

.contacts {
  text-align: center;
  font-size: 2rem;
  margin: auto;

  p {
    margin: 0;
  }
}

.control-group {
    flex-wrap: nowrap;
}

.messenger {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  font-size: 2rem;
  color: #fff;
  padding: 0;
  margin: 0;

  i {
    display: block;
    text-align: center;
  }

  &.tg {
    background-color: $telegram;

    &:hover {
      background-color: darken($telegram, 10);
    }
  }

  &.wa {
    background-color: $whatsapp;

    &:hover {
      background-color: darken($whatsapp, 10);
    }
  }

  &.vb {
    background-color: $viber;

    &:hover {
      background-color: darken($viber, 10);
    }
  }
}

@media (max-width: ($tablet)-1) {
    .title {
        margin-bottom: 0;
    }

    .container {
        background-position: bottom right;
    }

    .row-root,
    .col {
        display: block;
    }

    .col-messenger {
        text-align: center;

        .field {
            display: inline-block;
            width: auto;
            text-align: left;
        }
    }

    .controls {
        margin-top: 0;

        .col {
            padding-top: 0;
            padding-bottom: 0;
        }
    }
}

@media (max-width: ($mobile)-1) {
    .row,
    .col {
        display: block;
    }
}
</style>
